var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrystals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2529 5L30.1373 14.0508L24.2062 17.0225L19.8746 11.314L27.2529 5ZM19.6795 11.7286L23.9164 17.3123L21.8612 24.1341L20.3461 14.8163L20.3243 14.6819L20.2184 14.5893L19.6916 14.1289L19.5876 11.9581L19.6795 11.7286ZM23.0185 27.3484L23.0466 27.3683L25.6371 20.248L23.0185 27.3484ZM25.642 20.2415L28.6455 18.4866L28.6583 18.4568L25.642 20.2415ZM21.4914 24.4403L21.4156 24.5598L20.1435 23.5619L19.7182 14.6849L19.9362 14.8754L21.4914 24.4403ZM22.6702 27.1025L22.6319 27.0755L22.1135 26.3923L22.0126 25.0624L24.3185 17.4085L29.9694 14.5772L28.9158 17.8433L25.418 19.9129L25.2947 19.9859L25.247 20.1154L22.6702 27.1025Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6421 20.2415L28.6457 18.4866L28.6584 18.4567L25.6421 20.2415ZM22.6678 27.1091L22.632 27.0755L22.1136 26.3923L22.0127 25.0624L24.3186 17.4084L29.9695 14.5771L28.9159 17.8432L25.4181 19.9129L25.2948 19.9858L25.2471 20.1154L22.6678 27.1091Z",
    fill: "#3F9243"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2529 5L30.1373 14.0508L24.2062 17.0225L19.8746 11.314L27.2529 5Z",
    fill: "#88CA8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.92871 17.1197L12.1629 8.28624L17.2262 25.6447L17.033 25.9045L14.3372 18.7796L9.92871 17.1197ZM21.7458 25.9263L19.2103 22.9765L17.5351 25.2293L12.5506 8.14111L19.9379 14.9144L21.7458 25.9263Z",
    fill: "#4CAF50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.92871 17.1196L12.1629 8.28613L16.8242 24.2664L17.033 25.9044L14.3372 18.7795L9.92871 17.1196Z",
    fill: "#3F9243"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1787 35.6569L30.067 34.0114L32.2405 30.8694L25.3601 34.331L24.1787 35.6569ZM25.9638 33.5846L31.816 30.6402L28.2052 30.8968L26.3928 33.0293L25.9638 33.5846Z",
    fill: "#4CAF50"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6428 34.3308L32.5232 30.8691L30.3497 34.0111L24.4614 35.6567L25.6428 34.3308Z",
    fill: "#3F9243"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67633 34.9989L7.07935 31.037L14.3968 34.2247L14.8556 34.7862L15.374 35.2742L16.3594 36.2017L9.67633 34.9989ZM11.1963 30.3174L13.8188 33.5174L13.8509 33.5567L7.30878 30.7067L11.1963 30.3174Z",
    fill: "#4CAF50"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67633 34.7842L7.07935 30.8223L14.3968 34.01L14.8556 34.5715L15.374 35.0595L16.3594 35.987L9.67633 34.7842ZM13.3904 33.1414L13.8188 33.3027L13.8509 33.342L13.3904 33.1414Z",
    fill: "#3F9243"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0678 15.8599L33.4452 24.2965L27.3741 25.0109L25.6911 20.258L25.7082 20.212L33.0678 15.8599ZM25.4669 20.8594L27.0079 25.2114L22.8406 33.4072L23.3578 28.2468L23.0468 27.3684L23.0898 27.2368L25.4669 20.8594ZM23.6092 36.2501L22.5283 36.2501L22.714 34.5605L27.3693 25.4049L33.1059 24.7299L23.6092 36.2501Z",
    fill: "#88CA8A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4668 20.8593L27.0079 25.2112L22.8406 33.407L23.3578 28.2466L23.0467 27.3682L23.0893 27.2376L25.4668 20.8593Z",
    fill: "#4CAF50"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6092 36.2497L22.5283 36.2497L22.6227 34.7398L27.3693 25.4046L33.1059 24.7295L23.6092 36.2497Z",
    fill: "#3F9243"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1287 24.7448L14.1342 19.5115L16.4793 25.6924L16.722 26.3923L15.7889 27.8563L16.722 31.3699L18.1132 35.0077L12.1287 24.7448ZM14.6436 34.0469L16.606 36.2037L18.3375 36.2037L11.7808 24.9594L6.48425 25.0789L8.02547 26.7728L11.4342 30.0035L14.6436 34.0469ZM6.25 24.6937L11.755 24.5695L13.872 19.0452L6.25002 16.1904L6.25 24.6937Z",
    fill: "#4CAF50"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.606 36.2037L18.3375 36.2037L11.7808 24.9594L6.48425 25.0789L8.02547 26.7728L11.4342 30.0035L14.6436 34.0469L16.606 36.2037ZM6.25 24.6937L11.755 24.5695L13.872 19.0452L6.25002 16.1904L6.25 24.6937Z",
    fill: "#88CA8A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6059 36.2037L18.3374 36.2037L11.7806 24.9595L6.48413 25.0789L8.02526 26.7728L11.4341 30.0035L14.6436 34.047L16.6059 36.2037Z",
    fill: "#3F9243"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2454 36.1814L23.0343 28.7179L19.9889 31.3317L20.6839 36.1884L22.2454 36.1814ZM20.2654 36.1881L19.5734 31.3524L16.3454 28.5601L18.7519 36.1812L20.2654 36.1881ZM19.7695 30.9917L16.2036 27.9072L19.232 23.6309L23.0128 28.208L19.7695 30.9917Z",
    fill: "#4CAF50"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2654 36.1881L19.5734 31.3524L16.3454 28.5601L18.7519 36.1812L20.2654 36.1881ZM19.7695 30.9917L16.2036 27.9072L19.232 23.6309L23.0128 28.208L19.7695 30.9917Z",
    fill: "#88CA8A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2654 36.188L19.5734 31.3523L16.3455 28.5601L18.7519 36.1812L20.2654 36.188Z",
    fill: "#3F9243"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "#337535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystals);
export default __webpack_public_path__ + "static/media/Crystals.046ac862a95450851407aaedd757a11f.svg";
export { ForwardRef as ReactComponent };